import HubFilter from "components/shared-components/RemoteTable/HubFilter/HubFilter";
import React, { useState } from "react";
import PaymentMethodFilterDropdown from "./PaymentMethodFilterDropdown";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button, Label } from "reactstrap";
import { PaymentMethodType } from "./contants";
import { Switch } from "antd";

const FilterTable = ({
  paymentMethodListParams,
  setPaymentMethodListParams,
  openCreateMethodModal,
}) => {
  const { t } = useTranslation(["paymentMethod"]);
  // const [is_level_2, setIsLevel2] = useState(true);
  const onChangePaymentMethod = method => {
    setPaymentMethodListParams(prev => ({
      ...prev,
      columnFilter: {
        ...prev.columnFilter,
        "filter[type]": method.value !== "all" ? method.value : undefined,
      },
    }));
  };
  return (
    <div className="d-flex flex-row justify-content-start align-items-center gap-2">
      {/* <Label
        className="d-flex align-items-center gap-1 mb-0"
        style={{ cursor: "pointer" }}
        htmlFor="is_level_2"
        onClick={() => setIsLevel2(!is_level_2)}
      >
        <Switch checked={is_level_2} onChange={setIsLevel2} />
        Địa chỉ 2 cấp
      </Label> */}
      <HubFilter
        label={t("table.hub")}
        isForOrder
        mainFilterParams={paymentMethodListParams}
        setMainFilterParams={setPaymentMethodListParams}
        isNotFilterChildHub={true}
        isHaveAllOption={true}
        isFilterAllDefault={true}
        addressLevel={3}
        handleSelectHub={(idsFilter, isSelectAll, hub) => {
          const flatIds = Array.isArray(idsFilter?.[0])
            ? idsFilter[0]
            : idsFilter;
          setPaymentMethodListParams(prev => ({
            ...prev,
            run: true,
            columnFilter: {
              ...prev.columnFilter,
              "filter[hub_id][in]": flatIds,
            },
          }));
        }}
      />
      <PaymentMethodFilterDropdown
        options={Object.keys(PaymentMethodType).map(key => ({
          label: t(`payment_method_type.${key}`),
          value: PaymentMethodType[key],
        }))}
        onChange={onChangePaymentMethod}
      />
      <Button
        className="btn btn-success btn-label"
        onClick={openCreateMethodModal}
      >
        <i className="fas fa-plus label-icon" />
        {t("actions.add_method")}
      </Button>
    </div>
  );
};

export default FilterTable;
